import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const NotificationsIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path
        d="M4.5 9.50021V12.5002V13.5002L3.5 15.5002L2 16.5002V19.0002H3.5L8 19.5002L8.5 21.0002L10.5 22.5002H13L15 21.5002L15.5 20.0002V19.0002H17H21.5V18.0002V17.0002L21 16.0002L19.5 14.0002L19 12.0002V9.50021L18 7.00021L17 5.00021L12.5 4.00021H9L6.5 6.50021L4.5 9.50021Z"
        fill={getColor(secondaryColor)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.77225 10.1076V11.345C5.77225 13.377 4.98432 15.3298 3.57414 16.7928L3.2498 17.1293V18.35H20.7498V17.1293L20.4255 16.7928C19.0153 15.3298 18.2274 13.377 18.2274 11.345V10.9173C18.2274 8.25444 17.1751 6.67917 15.9238 5.74444C14.631 4.77874 13.0573 4.45 12.0243 4.45C9.45204 4.45 7.93108 5.4235 7.03101 6.5653C6.10214 7.74364 5.77997 9.17434 5.77225 10.1076ZM5.69594 5.51288C6.93221 3.94458 8.9541 2.75 12.0243 2.75C13.3423 2.75 15.2952 3.15299 16.9411 4.38246C18.6286 5.64291 19.9274 7.72627 19.9274 10.9173V11.345C19.9274 12.9369 20.5447 14.4668 21.6494 15.613L22.0718 16.0512C22.3143 16.3028 22.4498 16.6386 22.4498 16.9881V20.05H1.5498V16.9881C1.5498 16.6386 1.68531 16.3028 1.92782 16.0512L2.35016 15.613C3.45495 14.4668 4.07225 12.9369 4.07225 11.345V10.0978C4.08155 8.8629 4.48951 7.04333 5.69594 5.51288Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.38368 20.0498C9.74174 21.1526 10.7777 21.9498 11.9998 21.9498C13.2219 21.9498 14.2579 21.1526 14.6159 20.0498H9.38368ZM15.5998 19.1998V18.3498H8.3998V19.1998H7.5498C7.5498 21.6575 9.54214 23.6498 11.9998 23.6498C14.4575 23.6498 16.4498 21.6575 16.4498 19.1998H15.5998Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8499 0V3.6H11.1499V0H12.8499Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default NotificationsIconFilled;
